import { cn } from "@/lib/utils";
import { Trash } from "lucide-react";
import { FC } from "react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { T } from "@/i18n";

interface ListProps {
  value: string[];
  onChange: (list: string[]) => void;
  className?: string;
  addTranslation?: string;
  mapper?: (
    val: string,
    i: number,
    onChange: (v: string) => void
  ) => React.ReactNode;
  id?: string;
}

export const TextList: FC<ListProps> = ({
  id,
  onChange,
  value,
  className,
  addTranslation,
  mapper,
}) => {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {value.map((val, i) => (
        <div className="flex gap-2">
          {mapper ? (
            mapper(val, i, (v) =>
              onChange(value.map((old, idx) => (idx === i ? v : old)))
            )
          ) : (
            <Input
              value={val}
              onChange={(e) => {
                onChange(
                  value.map((old, idx) => (idx === i ? e.target.value : old))
                );
              }}
            />
          )}
          <Button
            type="button"
            variant="ghost"
            className="text-destructive"
            onClick={() => {
              onChange(value.filter((_, j) => j !== i));
            }}
          >
            <Trash />
          </Button>
        </div>
      ))}
      <Button
        id={id}
        type="button"
        variant="outline"
        onClick={() => {
          onChange([...value, ""]);
        }}
      >
        <T tKey={addTranslation ?? "common.inputs.textlist.add"} />
      </Button>
    </div>
  );
};
